// extracted by mini-css-extract-plugin
module.exports = {"partnershipBeginContainer":"PartnershipThankYou_partnershipBeginContainer__3Rfp5"};